import { gql } from '@apollo/client';

const PHOTO_FRAGMENT = gql`
  fragment PhotoData on Photo {
    id
    isPublish
    isPrimary
    original
    compressed
    size
    type
  }
`;

const QUESTION_FRAGMENT = gql`
  fragment QuestionData on SiteVisitQuestion {
    id
    title
    description
    type
    category
    required
    help
    helpImages
    mapType
    colors {
      point
      line
      fill
    }
    mode
    options
    result
  }
`;

const CATEGORY_FRAGMENT = gql`
  fragment CategoryData on SiteVisitCategory {
    id
    title
    description
    type
    icon
    questions {
      ...QuestionData
    }
  }
  ${QUESTION_FRAGMENT}
`;

const SITE_VISIT_MAP_FRAGMENT = gql`
  fragment SiteVisitMapData on SiteVisitMap {
    address
    coordinates
    city
    state
    county
  }
`;

const SITE_VISIT_FRAGMENT = gql`
  fragment SiteVisitData on SiteVisit {
    id
    userId
    title
    map {
      ...SiteVisitMapData
    }
    preview {
      ...PhotoData
    }
    categories {
      ...CategoryData
    }
    createdAt
    updatedAt
  }
  ${SITE_VISIT_MAP_FRAGMENT}
  ${PHOTO_FRAGMENT}
  ${CATEGORY_FRAGMENT}
`;

export const CREATE_SITE_VISIT = gql`
  mutation CreateSiteVisit($input: SiteVisitCreateInput!) {
    siteVisitCreate(input: $input) {
      ...SiteVisitData
    }
  }
  ${SITE_VISIT_FRAGMENT}
`;

export const UPDATE_SITE_VISIT = gql`
  mutation UpdateSiteVisit($id: ID!, $input: SiteVisitUpdateInput!) {
    siteVisitUpdate(id: $id, input: $input) {
      ...SiteVisitData
    }
  }
  ${SITE_VISIT_FRAGMENT}
`;

export const DELETE_SITE_VISIT = gql`
  mutation DeleteSiteVisit($id: ID!) {
    siteVisitDelete(id: $id)
  }
`;
